//-- Copyright (c) 2021 TMT Insights Group, LLC
import { PayloadAction, createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../_utils/axios';
import { OrderJobTask } from './slice_types';

export interface TaskDrawerState {
  currentTask: OrderJobTask | null;
  loading: boolean;
}

const initialState: TaskDrawerState = {
  currentTask: null,
  loading: false,
};

export const getCurrentTask = createAsyncThunk('taskDrawer/getCurrentTask', async (id: string) => {
  return axios.get(`/core/tasks/${id}/`).then((res) => res.data.data);
});

export const refreshCurrentTask = createAsyncThunk('taskDrawer/getCurrentTask', async (id: string, { getState }) => {
  const { taskDrawer } = getState() as { taskDrawer: TaskDrawerState };
  if (taskDrawer.currentTask && id === taskDrawer.currentTask.id) {
    return axios.get(`/core/tasks/${id}/`).then((res) => res.data.data);
  } else {
    throw new Error('Mismatch cannot refresh');
  }
});

const taskDrawerSlice = createSlice({
  name: 'taskDrawer',
  initialState,
  reducers: {
    setCurrentTask(state, { payload }: PayloadAction<OrderJobTask | null>) {
      state.currentTask = payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCurrentTask.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCurrentTask.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getCurrentTask.fulfilled, (state, { payload }) => {
      state.currentTask = payload;
      state.loading = false;
    });
  }
});

export const { setCurrentTask } = taskDrawerSlice.actions;

export default taskDrawerSlice.reducer;
